export const signupPaymentStartRoute = [
  '/signup', "deferred-value-props"
]

export const signupPaymentStartWithPhoneRoute = [
  '/signup', "phone"
]

export const signupPaymentStartWithEmailRoute = [
  '/signup', "email"
]

export const signupDeferredValuePropsRoute = [
  '/signup', "deferred-value-props"
]

export const signupDeferredPrivacySecurityRoute = [
  '/signup', "deferred-privacy-security"
]

export const signupDeferredWelcomeRoute = [
  '/signup', "deferred-welcome"
]

export const paymentSuccessRoute = [
  '/signup', "deferred-welcome"
]
